import React, { useContext, useEffect, useState } from "react"
import { ContextProvider } from "../context/Context"
import { useNavigate, Link } from "react-router-dom"
import { useLazyQuery } from "@apollo/client"
import { LOGIN } from "../graphql/Login"
import Loading from "../components/Loading"
import { saveToLocalStorage } from "../helpers/saveToLocalStorage"
import { removeFromLocalStorage } from "../helpers/removeFromLocalStorage"

const Login: React.FC = () => {
  interface IUserInput {
    email: string | null
    password: string | null
  }

  const [inputUser, setInputUser] = useState<IUserInput | null>({
    email: "test@mail.com",
    password: "testpassword",
  })
  const navigate = useNavigate()
  const { dispatch } = useContext<any>(ContextProvider)
  const [login, { loading, error, data }] = useLazyQuery(LOGIN)
  const [saveLogin, setSaveLogin] = useState<boolean>(false)

  useEffect(() => {
    const lStorage: IUserInput | null = JSON.parse(
      localStorage.getItem("userInput")!
    )
    if (lStorage) {
      setInputUser({ email: lStorage.email, password: lStorage.password })
      setSaveLogin(true)
    }

    if (data?.login) {
      dispatch({ type: "LOGIN", payload: data.login })
      localStorage.setItem("token", data.login.token)
      navigate(`/main/${data.login._id}`)
    }
  }, [data, dispatch, navigate])
  const handleSaveLogin = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    if (event.currentTarget.checked) {
      saveToLocalStorage("userInput", inputUser)
      setSaveLogin(true)
    } else {
      removeFromLocalStorage("userInput")
      setSaveLogin(false)
    }
  }

  const onChangeHandle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const user: any = { [event.target.id]: event.target.value }
    setInputUser((c) => ({ ...c, ...user }))
  }

  const loginHandle = async () => {
    if (saveLogin) {
      saveToLocalStorage("userInput", inputUser)
    }
    await login({
      variables: {
        email: inputUser?.email,
        password: inputUser?.password,
      },
    })
  }

  const keyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    switch (event.key) {
      case "Enter":
        loginHandle()
        break
      default:
        break
    }
  }

  if (loading) return <Loading />

  return (
    <div className="flex flex-col items-center justify-center h-screen text-white bg-slate-800">
      <form className="flex flex-col px-12 py-6 space-y-2 rounded-lg w-80 bg-slate-900 drop-shadow-md-white">
        <h1 className="mb-6 text-2xl text-center">Note Moko</h1>

        <div className="flex flex-col">
          <label htmlFor="email">Email</label>
          <input
            className="p-1 text-black rounded"
            value={inputUser?.email || ""}
            autoComplete="email"
            type="text"
            name="email"
            id="email"
            placeholder="Email"
            onChange={(event) => {
              onChangeHandle(event)
            }}
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="password">Password</label>
          <input
            className="p-1 text-black rounded-sm"
            value={inputUser?.password || ""}
            autoComplete="current-password"
            type="password"
            name="password"
            id="password"
            placeholder="Password"
            onChange={(event) => {
              onChangeHandle(event)
            }}
            onKeyUp={(event) => {
              keyPress(event)
            }}
          />
        </div>
        <div>
          {error && (
            <p className="text-center text-red-400">
              {" "}
              Invalid Email and Password!
            </p>
          )}
        </div>
        <div className="space-x-2 text-center ">
          <label htmlFor="credentials">Remember Login?</label>
          <input
            className="rounded-full "
            type="checkbox"
            name="credentials"
            id="credentials"
            checked={saveLogin}
            onChange={(event) => {
              handleSaveLogin(event)
            }}
          />
        </div>
        <div className="flex justify-center p-3">
          <button
            type="button"
            className="px-2 py-1 bg-red-400 border-red-300 border-solid rounded-sm hover:bg-red-500"
            onClick={() => {
              loginHandle()
            }}
          >
            Login
          </button>
        </div>
        <div className=" border-t-[1px] text-center p-2 underline">
          <Link to={"/adduser"}>Create Account</Link>
        </div>
      </form>
    </div>
  )
}

export default Login
